export enum ProcessoExportacaoSimplesTipoRegistroEnum {

  DEBITO_GRP = "Débito no GRP",
  NAO_ENCERRAMENTO = "Encerramento não realizado",
  RECOLHIMENTO_INSUFICIENTE = "Falta ou insuficiência de pagamento",
  NAO_CADASTRADO_PREFEITURA = "Sem cadastro no município"
}
